<template>
  <div class="flow-item" :class="hasChildren ? 'flow-item--branch' : 'flow-item--leaf'">
    <div class="flow-item__row">
      <a-checkbox
        :disabled="childItem.required"
        :checked="isChildChecked"
        @change="handleChildChange"
      >
        {{ childItem.title }}
      </a-checkbox>

      <span
        v-if="childItem.actions && childItem.actions.length"
        class="flow-item__actions"
      >
        (功能：
        <a-checkbox
          v-for="action in childItem.actions"
          :key="action.key + action.permissionId"
          :checked="action.checked"
          @change="e => handleActionChange(e, action)"
        >
          {{ action.label }}
        </a-checkbox>
        )
      </span>
    </div>

    <!-- 平铺模式（flatten）下由父级统一展开叶子菜单；层级模式下递归渲染全部子级 -->
    <div v-if="!flatten && hasChildren" class="flow-item__children">
      <PermissionFlowItem
        v-for="subChild in childItem.children"
        :key="subChild.permissionId"
        :child-item="subChild"
        :parent-group="parentGroup"
        :group-index="groupIndex"
        :flatten="flatten"
        @child-change="$emit('child-change', $event)"
        @action-change="$emit('action-change', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PermissionFlowItem',
  props: {
    // 菜单节点（层级模式下包含全部层级，平铺模式下为叶子菜单）
    childItem: {
      type: Object,
      required: true
    },
    // 所属顶层分组
    parentGroup: {
      type: Object,
      required: true
    },
    groupIndex: {
      type: Number,
      required: true
    },
    // true：流式平铺（仅显示叶子菜单）；false：显示全部层级（默认，叶子在同一行内横向排列）
    flatten: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 是否带下级菜单：带下级则独占一行并递归，否则与同级叶子横向排列
    hasChildren() {
      return !!(this.childItem.children && this.childItem.children.length)
    },
    isChildChecked() {
      return !!(this.parentGroup.permissionList && this.parentGroup.permissionList.includes(this.childItem.permissionId))
    }
  },
  methods: {
    handleChildChange(e) {
      this.$emit('child-change', {
        e,
        groupItem: this.parentGroup,
        index: this.groupIndex,
        childItem: this.childItem
      })
    },
    handleActionChange(e, actionItem) {
      this.$emit('action-change', {
        e,
        groupItem: this.parentGroup,
        index: this.groupIndex,
        childItem: this.childItem,
        actionItem
      })
    }
  }
}
</script>

<style scoped lang='less'>
.flow-item {
  // 固定行高，避免继承祖先的大 line-height 把每行撑高
  line-height: 24px;

  &__row {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  // 隶属该页面的操作按钮，用括号包裹区分
  &__actions {
    padding: 0 10px;
  }

  // 子级区域：叶子横向平铺，带下级的节点独占一行
  &__children {
    padding-left: 24px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 0 20px; // 行间距交给行高控制、列间距 20px
  }

  // 叶子节点：与同级叶子在同一行内横向排列
  &--leaf {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
  }

  // 带下级的节点：强制换行独占一行，其子级在下方继续按同样规则排布
  &--branch {
    flex: 0 0 100%;
  }
}
</style>
